import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
};
